<template>
  <div>
    <v-card-title class="dialog_header">{{ formTitle }}</v-card-title>
    <v-card-text>
      <v-form @submit.prevent="handleSubmit">
        <formWrapper :validator="$v.form">
          <v-container>
            <v-row>
              <v-col cols="12">
                <locale-select
                  v-if="isEdit"
                  v-model="locale"
                  @change="changeLocale"
                />
              </v-col>
              <v-col cols="12">
                <v-col cols="12" class="px-0">
                  <new-image-upload
                    :isPngImage="true"
                    class="file-upload__image"
                    :imgUrl="form.icon ? form.icon.path : ''"
                    :imgId="isEdit && form.icon ? form.icon.id : ''"
                    :reset="resetImage"
                    @fileSelected="handleImageSelect"
                    @ImageUpdated="handleImageUpdate"
                    :maxSize="maxSize"
                  />
                </v-col>
              </v-col>
              <v-col cols="12">
                <form-group name="name" attribute="fields.name">
                  <template slot-scope="{ attrs, listeners }">
                    <v-text-field
                      v-bind="attrs"
                      v-on="listeners"
                      outlined
                      v-model="form.name"
                    ></v-text-field>
                  </template>
                </form-group>
              </v-col>

              <v-col cols="12">
                <v-btn
                  :loading="loadingButton"
                  type="submit"
                  :disabled="$v.form.$invalid"
                  class="primary"
                  >{{ textButton }}</v-btn
                >
              </v-col>
            </v-row>
          </v-container>
        </formWrapper>
      </v-form>
    </v-card-text>
  </div>
</template>

<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import { ShowData } from "@/helpers/apiMethods";

export default {
  name: "FormAction",
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    dialog: {
      type: Boolean,
      default: false,
    },
    table_ref: {
      type: Object,
      default: () => {},
    },
    item: {
      type: Object,
      default: () => {},
    },
    index: {
      type: String,
      default: "",
    },
    responseName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      form: {
        name: "",
        icon: "",
        service: 0,
      },
      maxSize: 512,
      reset: false,
      loadingButton: false,
      locale: this.locale,
      resetImage: false,
    };
  },
  computed: {
    formTitle() {
      if (this.isEdit) {
        return this.$t("headings.edit");
      } else {
        return this.$t("headings.create");
      }
    },
    textButton() {
      if (!this.isEdit) {
        return this.$t("button.create");
      } else {
        return this.$t("button.edit");
      }
    },
  },
  watch: {
    dialog: {
      handler(value) {
        if (!value) {
          this.resetData();
          setTimeout(() => {
            this.resetImage = false;
          }, 1000);
        }
      },
      immediate: true,
    },
    isEdit: {
      handler(value) {
        if (value) {
          this.handleShowData();
        }
      },
      immediate: true,
    },
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(150),
      },
    },
  },
  methods: {
    handleImageUpdate(photo) {
      this.$emit("update_main_image", photo);
    },
    handleImageSelect(photo) {
      this.form.icon = photo.file;
    },
    changeLocale(locale) {
      this.locale = locale;
      this.handleShowData(locale);
    },

    resetData() {
      this.$v.form.$reset();
      Object.keys(this.form).map((formKey) => {
        return (this.form[formKey] = "");
      });
      this.form.service = 0;
      this.resetImage = true;
      this.loadingButton = false;
    },
    handleSubmit() {
      if (this.isEdit) {
        delete this.form.icon;
      }
      this.loadingButton = true;
      const formData = new FormData();

      Object.keys(this.form).forEach((formKey) => {
        formData.append(formKey, this.form[formKey]);
      });

      if (!this.isEdit) {
        // in case create
        this.table_ref
          .handleOnCreate(this.$route.name, formData, "topic")
          .finally(() => {
            this.loadingButton = false;
          });
      } else {
        // in case edit
        formData.append("_method", "put");
        formData.append("locale", this.locale);
        this.table_ref
          .handleOnEdit(
            this.$route.name,
            formData,
            this.item.id,
            "topic",
            this.index
          )
          .finally(() => (this.loadingButton = false));
      }
    },
    handleShowData(locale = "en") {
      ShowData({ reqName: this.$route.name, param: this.item.id, locale })
        .then((res) => {
          const dataResponse = res.data["topic"];
          this.form = dataResponse;
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>
